/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      window.PXUTheme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider($section);
    }

    // Setup tab switching for 2-collection sections
    this.setupTabs($section);

  },
  createSlider: function($section) {

    if($('.featured-collection.layout--slider .slider-gallery').length > 0){
      let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');
      let enableNav = this.enable_nav || false;
      
      $(featuredCollectionSlider).addClass('owl-carousel');
      setTimeout(function() { 
        $(featuredCollectionSlider).owlCarousel({
          loop:true,
          margin:0,
          nav: enableNav,
          navText: ['<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-left"><path d="M7.57129 1.60034C7.37955 1.60046 7.18785 1.67823 7.04199 1.83472L1.79199 7.4353C1.49902 7.74784 1.499 8.25364 1.79199 8.56616L7.04199 14.1658C7.33496 14.4781 7.80861 14.4781 8.10156 14.1658C8.39456 13.8532 8.39456 13.3474 8.10156 13.0349L4.12891 8.79663H13.1777C13.6061 8.79519 14 8.54062 14 8.02026C13.9999 7.50003 13.5968 7.24976 13.2002 7.24976H4.08691L8.10156 2.96558C8.39456 2.65304 8.39456 2.14725 8.10156 1.83472C7.95559 1.67808 7.76319 1.60034 7.57129 1.60034Z" fill="#383838"></path></svg>', '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-right"><path d="M7.75 1.60034C7.94174 1.60046 8.13344 1.67823 8.2793 1.83472L13.5293 7.4353C13.8223 7.74784 13.8223 8.25364 13.5293 8.56616L8.2793 14.1658C7.98632 14.4781 7.51268 14.4781 7.21973 14.1658C6.92673 13.8532 6.92673 13.3474 7.21973 13.0349L11.1924 8.79663H2.14355C1.71516 8.79519 1.32132 8.54062 1.32129 8.02026C1.32134 7.50002 1.72446 7.24976 2.12109 7.24976H11.2344L7.21973 2.96558C6.92673 2.65304 6.92673 2.14725 7.21973 1.83472C7.3657 1.67807 7.5581 1.60034 7.75 1.60034Z" fill="#383838"></path></svg>'],
          dots: false,
          responsive:{
            0:{
              items:1
            },
            320:{
              items: 3
            },
            1000:{
              items:3
            },
            1200:{
              items:4
            }
          }
        })
      }, 500);
    }

  },
  setupTabs: function($section) {
    const tabs = $section.find('.collection-tab');
    const contents = $section.find('.collection-content');
    
    if (tabs.length > 0 && contents.length > 0) {
      tabs.on('click', function() {
        const targetCollection = $(this).data('collection');
        
        // Remove active class from all tabs and contents
        tabs.removeClass('active');
        contents.removeClass('active');
        
        // Add active class to clicked tab and corresponding content
        $(this).addClass('active');
        $section.find('[data-collection-content="' + targetCollection + '"]').addClass('active');
      });
    }
  },
  unload: function($section) {
    // let $slider = $section.find('.flickity-enabled');
    // $slider.flickity('destroy');
  }
}

/******/ })()
;